import { openPostApi } from './Api';
import ReactSecureStorage from 'react-secure-storage';

export const login = async (id, password) => {
  const url = '/admin/member/sign-in';
  try {
    const data = { email: id, password: password };
    const response = await openPostApi(url, data);
    // 로그인 성공
    if (response.statusCode === 200) {
      // window.localStorage.setItem(
      //   'accessToken',
      //   response.data.tokenInfo.accessToken,
      // );
      // window.localStorage.setItem(
      //   'refreshToken',
      //   response.data.tokenInfo.refreshToken,
      // );

      ReactSecureStorage.setItem('accessToken', response.data.tokenInfo.accessToken);
      ReactSecureStorage.setItem('refreshToken', response.data.tokenInfo.refreshToken);
      ReactSecureStorage.setItem('uid', response.data.member.id);
      ReactSecureStorage.setItem('email', response.data.member.email);
      ReactSecureStorage.setItem('authenticated', true);
      ReactSecureStorage.setItem('memberType', response.data.memberType);
      ReactSecureStorage.setItem('org', response.data.member.initialOrgName);
      ReactSecureStorage.setItem('code', response.data.hospital.countryCode);
      return response;
    } else {
      return response;
    }
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};
